import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
    },
    navButton: {
        width: '48px',
    },
    slide: {
        display: 'flex',
        justifyContent: 'center',
    },
    swiper: {
        width: '100%',
    },
}));
